import { fontConstants } from '../constants';

const initialState = {
    loading: false,
    fontdetails: [],
    error: null
};

const fontReducer = (state = initialState, action) => {
    switch (action.type) {
        case fontConstants.FETCH_FONTDETAILS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case fontConstants.FETCH_FONTDETAILS_SUCCESS:
            return {
                ...state,
                fontdetails: action.fontdetails,
                loading: false,
                error: null
            };
        case fontConstants.FETCH_FONTDETAILS_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            };
        case fontConstants.UPDATE_FONTDETAILS_FROM_SOCKET:
            return {
                ...state,
                fontdetails: action.fontdetails,
                error: null
            };
        default:
            return state;
    }
};

export default fontReducer;
